module.exports = __webpack_public_path__ + "media/images/icons/immediate-106beeb8c569eec71ac9773fbad63d28.png";